export enum TemplatePurposeEnum {
    Invitation = 1,
    Reminder = 3
}
